var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.544 6.182V2.364H7.817A1.636 1.636 0 0 0 6.181 4v9.818a1.636 1.636 0 0 0 1.636 1.637h6.547A1.636 1.636 0 0 0 16 13.818v-6h-3.82a1.636 1.636 0 0 1-1.637-1.636h.001Z",
    fill: "#666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.635 6.182V2.636l4.091 4.091h-3.545a.545.545 0 0 1-.546-.545ZM4 5.636a1.09 1.09 0 0 1 1.09-1.09v9.272a2.727 2.727 0 0 0 2.728 2.727h6a1.09 1.09 0 0 1-1.09 1.091H7.878A3.88 3.88 0 0 1 4 13.757v-8.12Z",
    fill: "#666"
  })));
};
export default SvgCopy;